import API from '@aws-amplify/api';
import { IRoleInput } from './NewRoleConstants';
import { Role } from 'sections/user-management/sections/roles/data/roles-constants';

export const createNewRole = async (role: IRoleInput): Promise<Role> => {
  try {
    const response = await API.post(import.meta.env.VITE_API_GATEWAY_NAME, '/roles', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: role,
      response: true,
    });

    return response.data;
  } catch {
    return Promise.reject();
  }
};
